import {
    dictionary,
    locale,
    _
  } from 'svelte-i18n';
  
  function setupI18n({
    withLocale: _locale
  } = {
    withLocale: 'en'
  }) {
    dictionary.set({
      en: {
        "home": "Home",
        "contact": "Contact",
        "about": "About",
        "projects":"Projects",
        "hi":"Ekmon AB",
        "vision":"Our vision is to invest in",
        "sustainable ideas":"sustainable ideas",
        "that":"that can help and support",
        "people": "people",
        "norrkoping": "in and around Norrköping, Sweden.",
        "p1":"Ekmon AB is a cosultancy company with focus on music, it/data and accounting. The company also works as a small venture capital firm with focus on green and sustainable investements.",
        "p2":"The company was founded in 2012 by the two brothers, Johan Eksmo and Anders Eksmo. The name Ekmon is derived from a small area just outside of Norrköping.",
        "p3":"Idéhusen Skandinavien AB is a construction and property development company with focus on sustainable development.",
        "p4":"Eksmo Buss is the small company with a personal connection. With a modern turist bus and offers rides to companies, churches, fotball teams and other groups.",
        "p5":"Epishine was founded on the basis of 30+ years of research in organic electronics and photovoltaics and the development of our breakthrough manufacturing process within printed organic solar cells. This unique manufacturing process, among other advantages, achieves a groundbreaking level of scalability in terms of manufacturing and provides industry-leading efficiency in low light conditions.", 
        "p6":"Ligna Energy was founded in 2017, as a result of a decade of research at Linköping University. The team is dedicated to innovative materials for organic materials and development of solutions utilizing materials from nature."  
      },
      sv: {
        "contact": "Kontakt",
        "about": "Om mig",
        "projects":"Projekt",
        "hi":"Ekmon AB",
        "vision":"Vår vison är att investera i",
        "sustainable ideas":"hållbara idéer",
        "that":"som kan hjälpa och stötta",
        "people": "människor",
        "norrkoping": "i och runt om Norrköping.",
        "p1":"Ekmon AB är ett bolag som bedriver konsultverksamhet inom sång och musik, it och ekonomi. Bolaget ägnar sig också åt investeringar i form av venturekapital i utvalda bolag med fokus på gröna idéer.", 
        "p2":"Verksamheten startades 2012 av bröderna Johan Eksmo och Anders Eksmo. Namnet Ekmon har sitt ursprung i en släktgård mellan Svärtinge och Simonstorp utanför Norrköping.", 
        "p3":"Idéhusen Skandinavien AB är ett företag inom byggnation och fastighetsutveckling som Idéfabriken är med och startar utifrån ett intresse beträffande hållbar förvaltning.",
        "p4":"Eksmo Buss är det lilla företaget med den personliga kontakten. Bolaget erbjuder resor med modern turistbuss och vänder sig främst till företag, föreningar, skolor, kyrkor och andra grupper.",
        "p5":"Prisvärd solenergi överallt! Epishine utvecklar och producerar tryckta solceller som endast består av organiska material. Med världens mest prisvärda, klimatvänliga och transportvänliga solceller vill Epishine accelerera elektrifieringen av utvecklingsländer med ett grönt alternativ.",
        "p6":"Ligna Energy startades 2017, som ett nästa steg av ett forskningsprojekt från Linköping Universitet. Teamet jobbar med utveckling av innovativa lösningar inom energilagring."  
      },

    });
    locale.set(_locale);
  }
  export {
    _,
    locale,
    setupI18n
  };